import { Truck, ShieldCheck, Palette, Hand } from "lucide-react";
import { useLang } from "@/contexts/LanguageContext";

export const ValuesBar = () => {
  const { t } = useLang();
  const values = [
    { icon: Palette, label: t({ fr: "Design tunisien unique", en: "Unique Tunisian design" }), emoji: "🎨" },
    { icon: ShieldCheck, label: t({ fr: "Vinyle premium durable", en: "Durable premium vinyl" }), emoji: "✨" },
    { icon: Truck, label: t({ fr: "Livraison gratuite dès 69$", en: "Free shipping over $69" }), emoji: "🚚" },
    { icon: Hand, label: t({ fr: "Fait main avec soin", en: "Handcrafted with care" }), emoji: "🤲" },
  ];

  return (
    <section className="border-y border-primary/10 bg-gradient-to-r from-transparent via-[hsl(var(--cream)/0.6)] to-transparent backdrop-blur-sm">
      <div className="container mx-auto px-4 py-6">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
          {values.map((v) => (
            <div
              key={v.label}
              className="group flex items-center gap-3 justify-center rounded-2xl border border-primary/10 bg-background/60 backdrop-blur-sm px-4 py-4 hover:border-primary/30 hover:bg-primary/5 hover:shadow-warm transition-all duration-300 cursor-default hover:-translate-y-0.5"
            >
              <div className="w-10 h-10 rounded-xl bg-primary/10 flex items-center justify-center group-hover:scale-110 transition-transform duration-300">
                <v.icon className="w-5 h-5 text-primary shrink-0" />
              </div>
              <span className="font-body text-sm text-muted-foreground group-hover:text-foreground transition-colors leading-tight">{v.label}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
